import { SortItem } from '../ss-api/responses/member.dashboard.license.response';

export class UpdaterVersionItem {
    ID: number;
    Version: string;
    VersionInt: number;
    Name: string;
    Description: string;
    IsAvailable: boolean;
    DownloadURL: string;
}

export class UpdaterVersionItemArray extends Array<UpdaterVersionItem> {
    public LastSort: SortItem;

    constructor(...items: UpdaterVersionItem[]) {
        super(...items);
        Object.setPrototypeOf(this, UpdaterVersionItemArray.prototype);
    }

}
